import { Box, ButtonProps } from '@mui/material';
import { Children, isValidElement, cloneElement, ReactNode, FC } from 'react';

interface IActionButtons {
	children: ReactNode;
}

const ActionButtons: FC<IActionButtons> = ({ children }) => {
	return (
		<Box
			sx={{
				gap: 2,
				display: 'flex',
				flexDirection: { xs: 'row', sm: 'row' },
				justifyContent: 'space-between',
				width: '100%',
			}}
		>
			{Children.map(children, (child: ReactNode) => {
				if (isValidElement<ButtonProps>(child)) {
					return cloneElement(child, {
						sx: { width: '100%', ...child.props.sx },
					});
				}
				return child;
			})}
		</Box>
	);
};

export default ActionButtons;
